import { SlabTypeDto } from './slab-type-dto.model';
import { ITMethodDto } from './it-method-dto.model';


export class ITSlabDto implements IITSlabDto {
    id!: number | undefined;
    financialYear!: string | undefined;
    slabType!: SlabTypeDto;
    itMethod!: ITMethodDto;
    fromAmount!: number;
    toAmount!: number;
    itPercentage!: number;
    educationCessPercentage!: number;
    surchargePercentage!: number;
    rebateFromAmount!: number;
    rebateToAmount!: number;
    maxRebateAmount!: number;
    standardDeduction!: number;
    fromAge!: number;
    toAge!: number;
    isActive!: boolean;

    constructor(data?: IITSlabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialYear = _data["financialYear"];
            this.slabType = _data["slabType"] ? SlabTypeDto.fromJS(_data["slabType"]) : <any>undefined;
            this.itMethod = _data["itMethod"] ? ITMethodDto.fromJS(_data["itMethod"]) : <any>undefined;
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
            this.itPercentage = _data["itPercentage"];
            this.educationCessPercentage = _data["educationCessPercentage"];
            this.surchargePercentage = _data["surchargePercentage"];
            this.rebateFromAmount = _data["rebateFromAmount"];
            this.rebateToAmount = _data["rebateToAmount"];
            this.maxRebateAmount = _data["maxRebateAmount"];
            this.standardDeduction = _data["standardDeduction"];
            this.fromAge = _data["fromAge"];
            this.toAge = _data["toAge"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ITSlabDto {
        data = typeof data === 'object' ? data : {};
        let result = new ITSlabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialYear"] = this.financialYear;
        data["slabType"] = this.slabType ? this.slabType.toJSON() : <any>undefined;
        data["itMethod"] = this.itMethod ? this.itMethod.toJSON() : <any>undefined;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        data["itPercentage"] = this.itPercentage;
        data["educationCessPercentage"] = this.educationCessPercentage;
        data["surchargePercentage"] = this.surchargePercentage;
        data["rebateFromAmount"] = this.rebateFromAmount;
        data["rebateToAmount"] = this.rebateToAmount;
        data["maxRebateAmount"] = this.maxRebateAmount;
        data["standardDeduction"] = this.standardDeduction;
        data["fromAge"] = this.fromAge;
        data["toAge"] = this.toAge;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IITSlabDto {
    id: number | undefined;
    financialYear: string | undefined;
    slabType: SlabTypeDto;
    itMethod: ITMethodDto;
    fromAmount: number;
    toAmount: number;
    itPercentage: number;
    educationCessPercentage: number;
    surchargePercentage: number;
    rebateFromAmount: number;
    rebateToAmount: number;
    maxRebateAmount: number;
    standardDeduction: number;
    fromAge: number;
    toAge: number;
    isActive: boolean;
}

